import { isEmpty } from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { AssignmentType, DemoSource } from 'models/enum';
import { CaseStudy, NewAssignment, SimChartAssignment, SimulationEhr } from 'models/ui';
import { RouteParams, RoutePath } from 'constants/app.constant';
import { apiHelper, appHelper } from 'helpers';
import { assignmentService, caseStudyService, simulationService } from 'services';
import { instructorSelectors } from 'redux/ducks/instructor';
import { studentActions, studentSelectors } from 'redux/ducks/student';
import { PageHeader } from 'components/common';
import AssignmentPreviewContent from 'components/common/assignment-preview-content/AssignmentPreviewContent';
import { ELSButton, ELSPageLoader } from 'components/common/els';
import './assignment.demo.scss';

interface MatchParams {
  assignmentId: string;
}

interface AssignmentDemoProps {
  fullAssignment: SimChartAssignment;
  assignmentDemoSource: string;
  assignmentDemoUrl: string;
  setAssignmentDemoSource: Function;
  setAssignmentDemoUrl: Function;
  newAssignment: NewAssignment;
  setFullAssignment: Function;
}

interface AssignmentDemoState {
  demoContent: CaseStudy | SimulationEhr;
  isLoading: boolean;
}

class AssignmentDemo extends Component<AssignmentDemoProps & RouteComponentProps<MatchParams>, AssignmentDemoState> {
  constructor(props) {
    super(props);
    this.state = {
      demoContent: null,
      isLoading: false
    };
  }
  componentDidMount() {
    this.props.setAssignmentDemoSource('');
    this.props.setAssignmentDemoUrl('');
    this.loadData();
  }

  loadData = async () => {
    try {
      this.setState({ isLoading: true });
      const { assignmentId } = this.props.match.params;
      const dataAssignment = (this.props.fullAssignment && { data: this.props.fullAssignment }) || (await assignmentService.getSimChartAssignment(Number(assignmentId)));
      if (isEmpty(this.props.fullAssignment)) {
        this.props.setFullAssignment(dataAssignment?.data);
      }
      let resData;
      if (this.props.fullAssignment?.assignmentType === AssignmentType.SIMULATION || dataAssignment?.data?.assignmentType === AssignmentType.SIMULATION) {
        resData = await simulationService.getSimulation(dataAssignment.data.simulationEhrId);
      } else {
        resData = await caseStudyService.getCaseStudy(dataAssignment.data.caseStudyId);
      }
      this.setState({ demoContent: resData.data });
    } catch (err) {
      apiHelper.showApiError(`can not load data ${err}`);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleSwitchToStudentViewClick = () => {
    if (this.props.fullAssignment?.assignmentType === AssignmentType.SIMULATION) {
      return appHelper.useLoader(
        simulationService.prepareDemoSimulationEhr({ simulationEhrId: this.state.demoContent.id }).then(({ data }) => {
          const { demoAssessmentId } = data;
          const path = RoutePath.student.simulationEhrLanding.replace(RouteParams.ASSESSMENT_ID, demoAssessmentId);
          this.props.setAssignmentDemoSource(DemoSource.SIMULAION_EHR_DEMO);
          this.props.setAssignmentDemoUrl(this.props.history.location.pathname);
          this.props.history.push(path);
        })
      );
    } else {
      return appHelper.useLoader(
        caseStudyService.prepareDemoCaseStudy({ caseStudyId: this.state.demoContent.id }).then(({ data }) => {
          const { demoAssessmentId } = data;
          const path = RoutePath.student.caseStudyLanding.replace(RouteParams.ASSESSMENT_ID, demoAssessmentId);
          this.props.setAssignmentDemoSource(DemoSource.CASE_STUDY_DEMO);
          this.props.setAssignmentDemoUrl(this.props.history.location.pathname);
          this.props.history.push(path);
        })
      );
    }
  };

  render() {
    const { isLoading, demoContent } = this.state;
    if (isLoading) {
      return <ELSPageLoader />;
    }

    return (
      demoContent && (
        <>
          <PageHeader title="SimChart Assignment">
            <ELSButton text="Switch to Student View" type="primary" onClick={this.handleSwitchToStudentViewClick} />
          </PageHeader>
          <div className="assignment-demo">
            <AssignmentPreviewContent demoContent={demoContent} assignmentType={this.props.fullAssignment?.assignmentType} />
          </div>
        </>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  assignmentDemoSource: studentSelectors.getAssignmentDemoSource(state),
  assignmentDemoUrl: studentSelectors.getAssignmentDemoUrl(state),
  fullAssignment: studentSelectors.getFullAssignment(state),
  newAssignment: instructorSelectors.getNewAssignment(state),
});

const mapDispatchToProps = (dispatch) => ({
  setAssignmentDemoSource: (source: string) => dispatch(studentActions.setAssignmentDemoSource(source)),
  setAssignmentDemoUrl: (url: string) => dispatch(studentActions.setAssignmentDemoUrl(url)),
  setFullAssignment: (payload: SimChartAssignment) => dispatch(studentActions.setFullAssignment(payload))
});

export { AssignmentDemo as BaseAssignmentDemo };
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AssignmentDemo);